import React, { createContext, useState, useEffect } from 'react'
import { config_url } from 'utils/js/endpoints'

export const ConfigContext = createContext({})

export const ConfigProvider = ({ children }) => {
    const [config, setConfig] = useState({
        activeLeagues: [],
    })
    const [loading, setLoading] = useState(true)
    const [error, setError] = useState(false)

    useEffect(() => {
        const cachedConfig = localStorage.getItem('webConfig')

        if (cachedConfig) {
            setConfig(JSON.parse(cachedConfig))
            setLoading(false)
        }

        fetch(`${config_url}/webConfig/webConfig.json`)
            .then(response => response.json())
            .then(data => {
                const configString = JSON.stringify(data)
                if (configString !== cachedConfig) {
                    setConfig(data)
                    localStorage.setItem('webConfig', configString)
                }
            })
            .catch(e => {
                setError(e)
            })
            .finally(() => {
                setLoading(false)
            })
    }, [])

    return (
        <ConfigContext.Provider value={{ loading, error, ...config }}>
            {children}
        </ConfigContext.Provider>
    )
}

export default ConfigContext
